<template>
  <div>
    <!-- 搜索框 -->

    <a-card title="系统探测">
        <a-button slot="extra" type="primary" @click="handleExportService('export_select')" :loading="isExporting">导出选中</a-button>

      <a-form layout="inline"  :form="form">
          <a-form-item label="系统编码">
               <SysAutoComplete ref="syscodeAss" @onSysCodeChange="handleSearchSyscodeChange"></SysAutoComplete>
          </a-form-item>
          <a-form-item label="所属领域">
            <a-select v-model="searchP.domain" style="width: 80px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="001">前台</a-select-option>
                <a-select-option value="002">中台</a-select-option>
                <a-select-option value="003">开放</a-select-option>
                <a-select-option value="004">基础</a-select-option>
            </a-select>
        </a-form-item>
          <a-form-item label="版本">
            <a-select v-model="searchP.version" placeholder="" style="width: 80px">
                <a-select-option value=""> 全部 </a-select-option>
                <a-select-option value="V3.0"> 3.0 </a-select-option>
                <a-select-option value="V5.0"> 5.0 </a-select-option>
            </a-select>
        </a-form-item>

        
                  <!-- :loading="this.loading.effects['domainname/select']" -->
          <a-form-item>
              <a-button
                  type="primary"
                  @click="handleSubmit"
                  :key="this.loading.key"

              >查询</a-button>
          </a-form-item>
          <a-form-item>
            <a-button
                    type="default"
                    :key="this.loading.key"
                    @click="handleSearchReset"
                >重置</a-button>
            </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}" :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <router-link
                class="mr10"
                :to="{
                path:'appnode',
                query: {
                    appcode: record.appcode,
                    appenname: record.appenname,
                    syscode: record.syscode,
                    domain:record.domain,
                    version:record.version,
                }
            }"
            >探测</router-link>
        </div>
      </template>

       <template slot="appcodet" slot-scope="text, record">
          <span>
            <router-link
                :to="{
                path:'/system/editapp',
                query: {
                    appcode: record.appcode,
                }
            }"
            >{{text}}</router-link>
          </span>
      </template>

       <template slot="syscodet" slot-scope="text, record">
          <span>
            <router-link
                :to="{
                path:'/system/edit',
                query: {
                    syscode: record.syscode,
                }
            }"
            >{{text}}</router-link>
          </span>
      </template>
      <template slot="domainNames" slot-scope="text">
                <span >{{ domainName[text] }}</span>
            </template>
    </a-table>

    <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />


  </div>
</template>
<script>
import SysAutoComplete from '@/components/SysCodeAutoComplete'
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = searchP;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
        scopedSlots: { customRender: 'syscodet' },
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        scopedSlots: { customRender: 'appcodet' },
    },
    {
        title: '应用英文简称',
        dataIndex: 'appenname',
        align: 'center',
        scopedSlots: { customRender: 'appenname' },
    },
    {
        title: '应用中文简称',
        dataIndex: 'appname',
        align: 'center',
        scopedSlots: { customRender: 'appname' },
    },
    
    // {
    //     title: '备注',
    //     dataIndex: 'remark',
    //     align: 'center',
    //     scopedSlots: { customRender: 'remark' },
    // },

    {
        title: '领域',
        dataIndex: 'domain',
        align: 'center',
        scopedSlots: { customRender: 'domainNames' },
    },
    {
        title: '版本',
        dataIndex: 'version',
        align: 'center',
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    },
];

const data = [];
let searchP={
    syscode:'',
    syslanguage:'JAVA',
    domain:'',
    version:'',
    total:0,
    pageSize:10,
    page:undefined,
};

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP:searchP,
            domainName:domainName,
            tLoading:true,
            selectedRowKeys: [],
            rowsType: 'checkbox',
        };
    },
    methods: {
        handleExportService(flag){
            let exportIds = this.selectedRowKeys.join(',')
            if (flag == 'export_select') {
                //导出选中
                if (!exportIds) {
                    this.message.error('请勾选需要导出的列')
                    return
                }
            } else {
                //导出所有
                if (exportIds) {
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }

            let businesstype = "fpExportJobInfoConfig"
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        exportbusinesstype:businesstype,
                        exportparamsdesc:'{}',
                        exportids:exportIds,
                        urlparams:false
                    }
                })
                .then((res) => {
                    if(res.data.success == '1'){
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();
                      
                    }
                    else{
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error('导出失败'+e.message)
                });
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        callback(key) {
            console.log(key);
        },
        handlePageChange(c_p){
            this.searchP.page = c_p;
            this.getAppList()
        },
        getAppList(){
            this.tLoading = true;
            let c_params = {
                ...this.searchP
            }
            this.$store.dispatch({
                type: "app/selectApp",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data;
                this.data = result.list;
                this.searchP.total = result.totalRecords;
                this.searchP.pageSize = result.pageSize;
                this.searchP.page = result.page;
            })
        },
        handleSearchReset(){
            this.searchP={
                syscode:'',
                syslanguage:'JAVA',
                domain:'',
                version:'',
                total:0,
                pageSize:10,
                page:undefined,
            };
            this.getAppList()
        },

        handleSubmit(){
            this.searchP.page = 1;
            this.getAppList()
        },
        handleNodeList(){
           
        },
        handleSearchSyscodeChange(value){
            this.searchP.syscode = value;
        },
    },
    components:{
        SysAutoComplete
    },
    mounted(){
        this.getAppList();
    },    
    watch: {
        '$route' () {
            this.$router.go(0);
        }
    },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
